import { render, staticRenderFns } from "./FooterComponentTalentpool.vue?vue&type=template&id=592eec5b&scoped=true"
import script from "./FooterComponentTalentpool.vue?vue&type=script&lang=ts"
export * from "./FooterComponentTalentpool.vue?vue&type=script&lang=ts"
import style0 from "./FooterComponentTalentpool.vue?vue&type=style&index=0&id=592eec5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592eec5b",
  null
  
)

export default component.exports